import React from "react";

import { useTranslation } from "react-i18next";

import { TeamLineupsMissingPlayers } from "@data-types/sport-stats/SportStatsTypes";
import { observer } from "mobx-react";

export default observer(function TeamLineupsMissingPlayers(props: {
    missingPlayers: TeamLineupsMissingPlayers;
}) {
    const { t } = useTranslation();

    function missingPlayerReason(type: string, reason: number) {
        const renderReason = ({
            iconClass,
            labelKey,
        }: {
            iconClass: string;
            labelKey: string;
        }) => (
            <div className="statistics--player__goal u-color--text--tertiary">
                <i className={`u-icon u-icon--xsml ${iconClass}`} />
                <div className="u-type--clamp" title={t(labelKey)}>
                    {t(labelKey)}
                </div>
            </div>
        );

        if (type === "missing") {
            switch (reason) {
                case 1:
                    return renderReason({
                        iconClass:
                            "u-icon--medical-cross u-color--sent--danger",
                        labelKey: "EVENT.STATISTICS.LINEUPS.OUT",
                    });
                case 3:
                    return renderReason({
                        iconClass: "u-icon--suspended u-color--sent--danger",
                        labelKey: "EVENT.STATISTICS.LINEUPS.SUSPENDED",
                    });
                case 11:
                    return renderReason({
                        iconClass: "u-icon--card u-icon--card--rotate u-icon--card--yellow",
                        labelKey: "EVENT.STATISTICS.LINEUPS.SUSPENDED",
                    });
                case 12:
                    return renderReason({
                        iconClass:
                            "u-icon--card u-icon--card--rotate u-icon--card--combined",
                        labelKey: "EVENT.STATISTICS.LINEUPS.SUSPENDED",
                    });
                case 13:
                    return renderReason({
                        iconClass:
                            "u-icon--card u-icon--card--rotate u-icon--card--red",
                        labelKey: "EVENT.STATISTICS.LINEUPS.SUSPENDED",
                    });
                default:
                    return renderReason({
                        iconClass: "u-icon--user--bold u-color--sent--danger",
                        labelKey: "EVENT.STATISTICS.LINEUPS.UNAVAILABLE",
                    });
            }
        }

        if (type === "doubtful" && reason === 1) {
            return renderReason({
                iconClass: "u-icon--medical-cross u-color--sent--warning",
                labelKey: "EVENT.STATISTICS.LINEUPS.DOUBTFUL",
            });
        }

        if (type === "doubtful") {
            return renderReason({
                iconClass: "u-icon--user--bold u-color--sent--warning",
                labelKey: "EVENT.STATISTICS.LINEUPS.UNAVAILABLE",
            });
        }

        return null;
    }

    return (
        <tr className="table__body__tr table__row">
            <td className="table__body__cell table__cell">
                <div className="u-display--f u-gap--3">
                    <div className="statistics--player__jersey">
                        <div className="statistics--player__number">
                            {props.missingPlayers.player.jerseyNumber}
                        </div>
                    </div>

                    <div className="statistics--player__title">
                        <div className="statistics--player__team w--100--max">
                            <div
                                className="statistics--player__name"
                                title={props.missingPlayers.player.name}
                            >
                                {props.missingPlayers.player.name}
                            </div>
                        </div>

                        <div className="statistics--player__info">
                            {missingPlayerReason(
                                props.missingPlayers.type,
                                props.missingPlayers.reason
                            )}
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
});
